export default {
  "hero.eyebrow": "USFANS SPREADSHEET RESOURCE HUB",
  "hero.title": "USFans Spreadsheet — Find Products, Links & Smarter Buying Guides",
  "hero.description": "Explore the USFans Spreadsheet, discover useful product links, compare categories, understand QC and shipping, and make better-informed buying decisions with our independent resource hub.",
  "hero.trust": "Independent Resource • Updated Guides • Multilingual Support",
  "hero.buyNow": "Buy It Now",
  "hero.explore": "Explore USFans Spreadsheet",

  "dropdown.label": "Choose a Category",
  "dropdown.placeholder": "Select a category to jump to the main website",

  "categories.title": "Explore USFans Spreadsheet Categories",
  "categories.description": "Pick a category below to open the matching section on the main website. Every button leads you straight to the products you want to browse.",

  "about.title": "What Is the USFans Spreadsheet?",
  "about.p1": "The USFans Spreadsheet is a structured product-discovery resource. Instead of opening dozens of tabs, it brings product links, categories, images and notes together in one organized place so you can scan, compare and click through faster.",
  "about.p2": "Think of it as a single table where each row is one product and each column holds a useful detail — the category, the name, the link and any extra notes. Because everything is grouped by category, you can quickly jump between shoes, hoodies, t-shirts, jackets and accessories without losing track of what you were looking for.",
  "about.p3": "A good spreadsheet also helps you think before you buy. You can check quality-control photos, review shipping details and compare a few options side by side before you commit to an order.",
  "about.cta": "Learn How the USFans Spreadsheet Works",

  "guide.title": "How to Use the Spreadsheet",
  "guide.step1.title": "Choose a category",
  "guide.step1.desc": "Start with the section that matches what you want, from shoes to accessories.",
  "guide.step2.title": "Scan and compare",
  "guide.step2.desc": "Read the names, links and notes to shortlist the products that fit your needs.",
  "guide.step3.title": "Check the details",
  "guide.step3.desc": "Review pricing, sizing, QC photos and shipping before you decide.",
  "guide.step4.title": "Open the product",
  "guide.step4.desc": "Click through to the main website to see the full listing and complete your order.",

  "cards.title": "USFans Guides & Information",
  "cards.description": "Independent, honest guides to help you understand the spreadsheet, shipping, QC and more before you buy.",
  "card.review.title": "USFans Review",
  "card.review.desc": "An independent overview covering ordering, warehouse, QC, shipping and the overall customer experience.",
  "card.shipping.title": "USFans Shipping Cost",
  "card.shipping.desc": "Understand how weight, dimensions, destination and shipping method can affect your total cost.",
  "card.coupon.title": "USFans Coupon",
  "card.coupon.desc": "Learn how to find and verify current coupon offers before you use them.",
  "card.discount.title": "USFans Discount Code",
  "card.discount.desc": "Understand discount-code conditions and how to check whether an offer is still valid.",
  "card.warehouse.title": "USFans Warehouse",
  "card.warehouse.desc": "Learn about storage, QC, consolidation and how parcels are prepared before shipping.",
  "card.legit.title": "Is USFans Legit?",
  "card.legit.desc": "Review trust, safety, payment, shipping and seller-related factors before you order.",

  "articleCta.title": "Read Our Beginner Guide",
  "articleCta.desc": "New to the USFans Spreadsheet? Start with our original, in-depth guide covering how it works, quality control, shipping costs and staying safe while you shop.",
  "articleCta.button": "Read the Full Guide",

  "finalCta.title": "Ready to Explore the USFans Spreadsheet?",
  "finalCta.desc": "Start with the spreadsheet, compare the information that matters and use our guides before making a decision.",
  "finalCta.button": "Explore USFans Spreadsheet",

  "category.shoes": "Shoes",
  "category.hoodies": "Hoodies / Sweaters",
  "category.tshirts": "T-Shirts",
  "category.jackets": "Jackets",
  "category.pants": "Pants / Shorts",
  "category.headwear": "Headwear",
  "category.sets": "Sets",
  "category.underwear": "Underwear / Underpants",
  "category.jersey": "Jersey",
  "category.accessories": "Accessories",
  "category.bags": "Bags",
  "category.belts": "Belts",
  "category.perfumes": "Perfumes",
  "category.other": "Other Stuff",

  "pillars.title": "USFans Spreadsheet Guides",
  "pillars.desc": "In-depth independent guides to help you understand every aspect of the USFans Spreadsheet experience.",
  "pillar.spreadsheet.title": "Spreadsheet Guide",
  "pillar.spreadsheet.desc": "What the USFans Spreadsheet is, how it works and how to use it step by step.",
  "pillar.review.title": "USFans Review",
  "pillar.review.desc": "Ordering, warehouse, QC, shipping and overall customer experience reviewed.",
  "pillar.shipping.title": "Shipping Cost",
  "pillar.shipping.desc": "How weight, dimensions and carrier choice affect your total shipping cost.",
  "pillar.coupon.title": "Coupon Guide",
  "pillar.coupon.desc": "How to find and verify current USFans coupon offers before you use them.",
  "pillar.discount.title": "Discount Code",
  "pillar.discount.desc": "Validity, conditions and how to apply USFans discount codes at checkout.",
  "pillar.warehouse.title": "Warehouse Guide",
  "pillar.warehouse.desc": "Storage, QC, consolidation and parcel preparation explained.",
  "pillar.legit.title": "Is USFans Legit?",
  "pillar.legit.desc": "Safety, payment security and trust factors to check before ordering.",
  "pillar.qc.title": "QC Guide",
  "pillar.qc.desc": "How to read quality control photos and what to check before approving.",
  "pillar.beginner.title": "Beginner Buying Guide",
  "pillar.beginner.desc": "Your first USFans order from account setup to delivery, step by step.",
  "pillar.safety.title": "Safety Guide",
  "pillar.safety.desc": "Essential precautions to protect your account, payments and privacy.",

  "readMore": "Read more",
};